export const isResume = !!process.env.VUE_APP_IS_RESUME

export const host = process.env.VUE_APP_BACKEND_URL || 'localhost:3000'
